// extracted by mini-css-extract-plugin
export default {"rebus":"ImageRebus_rebus__v90ZX"};